import { render, staticRenderFns } from "./MetadataEdit.vue?vue&type=template&id=103e3dc2&scoped=true&"
import script from "./MetadataEdit.vue?vue&type=script&lang=js&"
export * from "./MetadataEdit.vue?vue&type=script&lang=js&"
import style0 from "./MetadataEdit.vue?vue&type=style&index=0&id=103e3dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e3dc2",
  null
  
)

export default component.exports